import React from 'react';
import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';
import { Table } from './table';
import AsrmEshre from '../../components/asrmEshre';

export function EkTedaviler() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="ektedaviler" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="ektedaviler" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="date-info">
            <TranslateStatic string="SonGuncellemeTarihi" /> 19.02.2025
          </div>

          <div className="text-content">
            <h3>
              <TranslateStatic string="EktedavilerH3" />
            </h3>
            <p>
              <TranslateStatic string="EkTedavilerP1" />
            </p>
            
            <h4>
              <TranslateStatic string="EkTedavilerH4" />
            </h4>
            <span>
              <TranslateStatic string="EkTedavilerSpan" />
            </span>
            
            <h2>
              <TranslateStatic string="EkTedavilerH2" />
            </h2>
            <Table />
          </div>
        </div>

        <AsrmEshre />
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
